import script from "./PUR08_001INS.vue?vue&type=script&setup=true&lang=js"
export * from "./PUR08_001INS.vue?vue&type=script&setup=true&lang=js"

import "./PUR08_001INS.vue?vue&type=style&index=0&id=5892b976&scoped=true&lang=css"
import "./PUR08_001INS.vue?vue&type=style&index=1&id=5892b976&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5892b976"]])

export default __exports__